import "./polyfill";
import objectFitImages from 'object-fit-images';
import Splitting from "splitting";

objectFitImages(null, {watchMQ: true});
Splitting();

/** Homepage **/
import "./homepage/video";
import "./homepage/events-accordion";
import "./homepage/video-modal";

/** Global **/
import "./global/anchor";

/** Slideshow **/
import "./slideshow/simple-slideshow";
import "./slideshow/viewer";
import "./slideshow/activity-entries";

/** Menus **/
import "./menu/main-nav";

/** Form **/
import "./form/contact-subject";

/** Lib **/
import './lib/tac';
